import { Request } from "stentor-models";
import {
    ChatMessageRequest
} from "../xapp/ChatServerMessage";

/**
 * Converts a Stentor Request (from a widget) to a ChatMessageRequest
 * 
 * it's text only - need to look into file exchange (this is widget-to-widget communication)
 *
 * @param botRequest
 * @param now
 * @returns
 */
export function requestToMessage(
    botRequest: Request,
    now: number = new Date().getTime()
): ChatMessageRequest {
    if (!botRequest) {
        return undefined;
    }

    const text = botRequest.rawQuery;

    const responseMessage: ChatMessageRequest = {
        type: "msg",
        timestamp: now,
        msg: {
            text,
        },
        endSession: false,
        user: undefined,
    };

    return responseMessage;
}
